import React, { useState, useEffect } from "react";
import { putEmpleado as modifEmpleado } from "../helpers/rutaEmpleados";
import { Modal, Button } from "react-bootstrap";
import "animate.css";

const ModalFormEmpleado = ({ empleado, handleClose, show }) => {
  const [formValues, setFormValues] = useState({
    nombre: "",
    apellido: "",
    dni: "",
    domicilio: "",
    telefono: "",
    cargo: "",
    sueldoActual: "",
    observaciones: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (empleado && empleado._id) {
      setFormValues({
        nombre: empleado.nombre || "",
        apellido: empleado.apellido || "",
        dni: empleado.dni || "",
        domicilio: empleado.domicilio || "",
        telefono: empleado.telefono || "",
        cargo: empleado.cargo || "",
        sueldoActual: empleado.sueldoActual ?? "",
        observaciones: empleado.observaciones || "",
      });
    }
  }, [empleado]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({
      ...formValues,
      [name]: name === "sueldoActual" ? value.replace(/[^\d.]/g, "") : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formValues,
        sueldoActual: Number(formValues.sueldoActual || 0),
      };

      const resp = await modifEmpleado(empleado._id, payload);
      console.log("✅ Empleado actualizado:", resp);

      if (!resp?.ok) {
        console.error("❌ Error al actualizar empleado:", resp?.error || resp);
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 2000);
    } catch (error) {
      console.error("❌ Error al actualizar empleado:", error);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Modificar Empleado</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group mt-2">
              <label>Apellido</label>
              <input
                type="text"
                className="form-control"
                name="apellido"
                required
                value={formValues.apellido}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Nombre</label>
              <input
                type="text"
                className="form-control"
                name="nombre"
                required
                value={formValues.nombre}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>DNI</label>
              <input
                type="text"
                className="form-control"
                name="dni"
                required
                value={formValues.dni}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Domicilio</label>
              <input
                type="text"
                className="form-control"
                name="domicilio"
                value={formValues.domicilio}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Teléfono</label>
              <input
                type="text"
                className="form-control"
                name="telefono"
                value={formValues.telefono}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Cargo</label>
              <input
                type="text"
                className="form-control"
                name="cargo"
                value={formValues.cargo}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Sueldo Actual</label>
              <input
                type="number"
                className="form-control"
                name="sueldoActual"
                min="0"
                step="0.01"
                required
                value={formValues.sueldoActual}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Observaciones</label>
              <input
                type="text"
                className="form-control"
                name="observaciones"
                value={formValues.observaciones}
                onChange={handleChange}
              />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="dark">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormEmpleado;